import { createStyles, Tooltip } from '@material-ui/core';
import React from 'react';

import { IPublisher } from '~/src/dash/api/console-api';
import { getPublishersNames } from '~/src/dash/api/publishers/publishers_methods';
import { EBool } from '~/src/dash/api/types/bool';
import { ModelPublisherSelectView } from '~/src/dash/components/model-publisher-select-view';
import { Col, Cols, Panel, spacing, Span, Text } from '~/src/dash/publicaUI';
import { SESSION_ACTIONS_SET } from '~/src/dash/reducers/session-reducers';
import { IStore } from '~/src/dash/reducers/store';
import {
  getDemoPublisherName,
  getResellerID,
  isIntegralplatform,
} from '~/src/dash/resellers/utils/importResellerConfig';
import { reload, RouteDashboards, RouteIASDashboard } from '~/src/dash/router/routes';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { primaryColor, whiteColor } from '~/src/dash/utils/material-dashboard-react';
import { checkUserInfoMasked, hasRole, ROLE_RESELLER, ROLE_SUPER } from '~/src/dash/utils/roles';
import { isOtteraResellerAdmin } from '~/src/dash/utils/ui';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {}

export const SelectPublisherView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    router: true,
    styles: () =>
      createStyles({
        publisherText: {
          color: whiteColor,
          fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
          fontSize: '1rem',
        },
        buttonLabelRoot: {
          color: whiteColor,
        },
        buttonLabelFocused: {
          color: primaryColor[0] + ' !important',
        },
        buttonInputRoot: {
          color: whiteColor,
          '&:before': {
            borderBottomColor: whiteColor,
          },
          '&:after': {
            borderBottomColor: primaryColor[0],
          },
        },
        publisherButton: {
          fontSize: '0.8rem',
          color: whiteColor,
          justifyContent: 'left',
          whiteSpace: 'nowrap',
          padding: '0',
        },
      }),
  },
  class extends React.Component<IProps, any> {
    selectPublisher = (publisher: IPublisher) => {
      this.props.dispatch(
        SESSION_ACTIONS_SET({
          publisher,
        }),
      );
      reload(isIntegralplatform() ? RouteIASDashboard : RouteDashboards, {
        publisherID: publisher.ID,
      });
    };

    queryPublisherV2 = (query: string) => {
      return getPublishersNames(this.props.session.publisher.ID, query);
    };

    render() {
      const { classes, session, user } = this.props;
      const theme = (window as any).CONFIG.theme;
      return (
        <div>
          {hasRole(user.user, [ROLE_SUPER, ROLE_RESELLER]) ||
          this.props.user.user.HasMultiplePublisherAssociations === EBool.EBool_TRUE ? (
            <ModelPublisherSelectView
              label=''
              searchHelperText='Search by Publisher ID or Publisher Name'
              model={session.publisher}
              onSelect={this.selectPublisher}
              queryV2={this.queryPublisherV2}
              appendReseller={getResellerID() < 0}
              TextFieldProps={{
                fullWidth: true,
              }}
              InputLabelProps={{
                classes: {
                  root: classes.buttonLabelRoot,
                  focused: classes.buttonLabelFocused,
                },
              }}
              InputProps={{
                classes: {
                  root: classes.buttonInputRoot,
                },
              }}
              search={this.props.location.search}
            />
          ) : (
            <div
              style={{
                margin: 'auto',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '56px',
              }}
            >
              <span
                className={classes.publisherText}
                style={{
                  display: 'block',
                  fontWeight: 500,
                  fontSize: '18px',
                }}
              >
                {checkUserInfoMasked(user.user) ? getDemoPublisherName() : session.publisher.Name}
              </span>
            </div>
          )}
          {(hasRole(user.user, [ROLE_SUPER]) ||
            isOtteraResellerAdmin(user.user, session.publisher)) && (
            <Panel>
              <Cols paddingTop={spacing.extraSmall} style={{ justifyContent: 'space-between' }}>
                <Col>
                  <Tooltip title='Click to Copy Publisher ID.' placement='bottom'>
                    <div
                      onClick={() => {
                        navigator.clipboard.writeText(session.publisher.ID);
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <Text
                        mini
                        color={theme.menuBarText}
                        style={{
                          whiteSpace: 'nowrap',
                          MozUserSelect: 'none', // firefox
                          WebkitUserSelect: 'none', // safari
                          msUserSelect: 'none', // ie
                          userSelect: 'none', // standard
                        }}
                      >
                        *PubID <Span bold>{session.publisher.ID}</Span>
                      </Text>
                    </div>
                  </Tooltip>
                </Col>
                <Col>
                  <Tooltip title='Click to Copy UUID.' placement='bottom'>
                    <div
                      onClick={() => {
                        navigator.clipboard.writeText(session.publisher.UUID);
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <Text
                        mini
                        color={theme.menuBarText}
                        style={{
                          whiteSpace: 'nowrap',
                          MozUserSelect: 'none', // firefox
                          WebkitUserSelect: 'none', // safari
                          msUserSelect: 'none', // ie
                          userSelect: 'none', // standard
                        }}
                      >
                        *UUiD <Span bold>{session.publisher.UUID.slice(0, 16)}</Span>
                      </Text>
                    </div>
                  </Tooltip>
                </Col>
              </Cols>
            </Panel>
          )}
        </div>
      );
    }
  },
);
